import moment from 'moment';

import { type DateTime } from '#packages/data-collection/types/date-time';

export class Clock {
  /**
   * Get the current date and time using internal clock.
   */
  now(): DateTime {
    return moment();
  }
}
